import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import TextService from '../../services/TextService';
import AuthorizationContext from '../../contexts/AuthorizationContext';

export const LoginSSOExpiredPage = () => {
    const { t } = useTranslation();
    return <ExceptionPage>
        {t('SSO_LOGIN_EXPIRED_PAGE', 'It looks like your sso session has already expired. Navigate please to initial page and repeat authentication process again.')}
    </ExceptionPage>;
};

export const NoAccessPage = () => {
    const { isEmployerRepAdmin, employerRep } = useContext(AuthorizationContext);
    const { t } = useTranslation();
    return <ExceptionPage>
        {t('NO_ACCESS_TO_PAGE', 'It looks like you don\'t have access to this page.')}
        { isEmployerRepAdmin && employerRep
            && <div dangerouslySetInnerHTML={{
                __html: TextService.sanitize(
                    t(
                        'NAVIGATE_TO_AVAILABLE_EMPLOYER',
                        'Please, navigate to <a href="/employer/{{employerId}}/positions">employer</a> available for you.',
                        { employerId: employerRep?.employerId },
                    ),
                ),
            }}/>
        }
    </ExceptionPage>;
};

export const InactiveUserPage = () => {
    const { availableEmployerIds, logout } = useContext(AuthorizationContext);
    const { t } = useTranslation();
    const [availableEmployerId] = availableEmployerIds;
    const query = new URLSearchParams(window.location.search);
    const initialUrl = query.get('url');

    const logoutUrl = !initialUrl
        ? '/logout'
        : `${window.location.origin}/loginsso?redirectUrl=${initialUrl}&needLogout=true`;
    const logoutText = ` back to <a href='${logoutUrl}'>login page</a> and try another user.`;
    const firstPart = 'Your user is limited.<br>';
    const appendix = availableEmployerId
        ? 'You can navigate to <a href="/employer/{{employerId}}/positions">employer</a> available for you.<br> Or go'
        : '<br>Go';
    if (initialUrl) {
        window.history.replaceState(null, '', window.location.pathname);
    }
    return <ExceptionPage>
        <span dangerouslySetInnerHTML={{
            __html: TextService.sanitize(
                t(
                    'INACTIVE_LIMITED_USER_PAGE',
                    `${firstPart}${appendix}${logoutText}`,
                    { employerId: availableEmployerId },
                ),
            ),
        }}/>
    </ExceptionPage>;
};

export const SuccessfulActivationPage = () => {
    const { t } = useTranslation();
    return <ExceptionPage>
        {t('SUCCESSFULL_ACTIVATION_PAGE', 'Your Paycor Smart sourcing account is now activated. You can calibrate job searches by clicking on a link within an email message that you will get, once jobs are posted in your ATS.')}
    </ExceptionPage>;
};

export const CalibrationDisabledPage = () => {
    const { t } = useTranslation();
    return <ExceptionPage>
        <span dangerouslySetInnerHTML={{
            __html: TextService.sanitize(
                t('CALIBRATION_DISABLED', 'Sorry, this link is inactive. To re-activate please contact Customer Success: <a href="mailto:PSS.success@paycor.com">PSS.success@paycor.com</a>.'),
            ),
        }}/>
    </ExceptionPage>;
};

export const CalibrationNotReadyPage = () => {
    const { t } = useTranslation();
    return <ExceptionPage>
        <span dangerouslySetInnerHTML={{
            __html: TextService.sanitize(
                t('CALIBRATION_NOT_READY', 'Sorry, it looks like we have a problem search calibration for this job. Please contact Customer Success: <a href="mailto:PSS.success@paycor.com">PSS.success@paycor.com</a>.'),
            ),
        }}/>
    </ExceptionPage>;
};

const useStyle = makeStyles(() => ({
    container: {
        display: 'flex',
        height: 'calc(100vh - 60px)',
    },
    root: {
        margin: 'auto',
        width: 350,
        textAlign: 'center',
        backgroundColor: 'white',
        padding: 40,
        boxShadow: 'rgb(38 36 51 / 25%) 0px 0px 4px',
        borderRadius: 3,
    },
}));

// Modified by AI on 05/26/2026. Edit #1.
const ExceptionPage = ({ children = null }) => {
    const classes = useStyle();
    return (
        <div className={classes.container}>
            <div className={classes.root}>
                {children}
            </div>
        </div>
    );
};

ExceptionPage.propTypes = {
    children: PropTypes.node,
};

export default ExceptionPage;
